import React from "react";
import { Link } from "react-router-dom";
import '../styles/landing.css'
import Hero from "components/Hero";
import MaxYield from "components/MaxYield";
import Opportunities from "components/Opportunities";
import PrivatePoolsCards from "components/PrivatePoolsCards";
import NewEcosystem from "components/NewEcosystem";
import OpenMarket from "components/OpenMarket";
import Team from "components/Team";
import Footer from "components/Footer";

const Home = () => {



  return (
    <div>
      <Hero />
      <MaxYield />
      <Opportunities />
      <PrivatePoolsCards />
      <NewEcosystem />
      <OpenMarket />
      <Team />
      <Footer />
    </div>
  );
};
export default Home;
